export default __webpack_public_path__ + "static/media/ziyuan_w.ee85d508.png";